import React from 'react';
import DotdotdotOriginal from 'react-dotdotdot';
import {
  ColProps,
  Col as ColFromGrid,
  Container as ContaienrFromGrid,
  Row as RowFromGrid,
  ContainerProps,
  RowProps,
} from 'react-grid-system';

export const Col: any = ColFromGrid as any as React.Component<ColProps, any>;
export const Container: any = ContaienrFromGrid as any as React.Component<
  ContainerProps,
  any
>;
export const Row: any = RowFromGrid as any as React.Component<RowProps, any>;

export const Dotdotdot: any = DotdotdotOriginal;
